import { enterpriseRequest } from '@/utils/request'

/* get */
export const reqWithdrawalList = (id, npp, page) =>
  enterpriseRequest.get('enterprise/withdrawal/driver', {
    params: { id, npp, page },
  })

export const reqDownloadWithdrawal = (id) =>
  enterpriseRequest.get('enterprise/withdrawal/excel', {
    params: { id },
    responseType: 'blob',
  })

/* export const reqInvoiceList = () => enterpriseRequest.get('enterprise/invoice') */

/* put */
export const reqDeleteWithdrawal = (id) =>
  enterpriseRequest.put(`enterprise/withdrawal/remove`, { withdrawalId: id })



// WEBPACK FOOTER //
// ./src/api/withdrawal/index.js